import React, { useState } from "react";
import iconRemove from "../../images/icons/remove_red32.png";

const AddBtn_v1 = (props) => {
  const [help, setHelp] = useState(false);
  const [valueInterface, setValueInterface] = useState("+");

  return (
    <div
      onMouseMove={() => setHelp(true)}
      onMouseOut={() => setHelp(false)}
      className={
        props.valueInterface !== undefined && props.valueInterface
          ? "btn_add_container_v1_img"
          : "btn_add_container_v1"
      }
      onClick={props.onClick}
    >
      {help && props.help ? (
        <p className="cls_hover_v1">{props.help}</p>
      ) : (
        <></>
      )}

      {/* <span className="btn_add_span_v1">
        {props.valueInterface !== undefined && props.valueInterface ? "x" : "+"}
      </span> */}
      {props.valueInterface !== undefined && props.valueInterface ? (
        <img src={iconRemove} alt="Закрыть" />
      ) : (
        <span className="btn_add_span_v1">+</span>
      )}
    </div>
  );
};

export default AddBtn_v1;
